import React from "react";
import { useTranslation } from "react-i18next";
import { Template } from "../../../assets/icons";

const TemplateStep = () => {
  const { t } = useTranslation();
  return (
    <div style={{ display: "grid", gridTemplateColumns: "1fr 4fr", textAlign: "left" }}>
      <div></div>
      <p style={{ margin: "0px" }}>{t("walkthrough.2of4")}</p>
      <div></div>
      <p style={{ fontSize: "20px", fontWeight: "bold", margin: "0px" }}>{t("walkthrough.template.title")}</p>
      <Template style={{ justifySelf: "center" }} />
      <p style={{ margin: "0px", alignContent: "center" }}>{t("walkthrough.template.content")}</p>
    </div>
  );
};

export default TemplateStep;
